<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    label="Файл"
    no-data-text="Файл не найден"
    :request="request"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { FilesApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompleteFile',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new FilesApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(...args) {
      return this.adapter.getAll(...args)
    },
  },
}
</script>
